import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export function useDeleteAgenda() {
  const queryClient = useQueryClient();

  const { mutateAsync, error, isLoading, reset } = useMutation<unknown, Error, string>({
    mutationFn: (reportId: string) => api.delete(`meeting-agendas/${reportId}`),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['meeting-agendas'] });
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  const deleteMeetingAgenda = async (reportId: string) => {
    return mutateAsync(reportId);
  };

  return {
    deleteMeetingAgenda,
    error,
    isLoading,
    reset,
  };
}
